import React from 'react';

const AppleAppStoreSvgIcon: React.FC<{ color?: string; size?: number }> = ({
  color = 'currentColor', // Inherit color from parent
  size = 25,
}) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Apple App Store"
    style={{ verticalAlign: 'middle', display: 'inline-block' }}
    x="0px"
    y="0px"
    width={size}
    height={size}
    viewBox="150 150 300 300"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M424.547,332.472h-45.833l-52.48-90.685c-8.325,9.178-13.397,21.311-13.397,34.653c0,8.909,2.267,17.281,6.238,24.602
        c0.404,0.739,0.809,1.455,1.257,2.171l65.597,113.363c4.957,8.565,15.937,11.5,24.523,6.555s11.529-15.897,6.571-24.463
        l-17.581-30.379h25.105c9.915,0,17.953-8.019,17.953-17.909S434.462,332.472,424.547,332.472z M206.895,375.005
        c-4.145,0-8.077,0.885-11.641,2.451l-12.277,21.212c-4.957,8.565-2.015,19.518,6.571,24.463
        c8.587,4.945,19.567,2.011,24.524-6.555l16.745-28.932C225.613,380.017,216.842,375.005,206.895,375.005z M313.807,332.472H262.75
        l75.869-131.087c4.958-8.566,2.016-19.519-6.57-24.464c-8.587-4.945-19.566-2.011-24.524,6.555l-7.524,13l-7.524-13
        c-4.958-8.566-15.938-11.5-24.524-6.555s-11.529,15.898-6.572,24.464l17.89,30.909l-57.98,100.178h-45.837
        c-9.915,0-17.953,8.018-17.953,17.908s8.038,17.909,17.953,17.909h162.353c1.269-3.054,1.976-6.396,1.976-9.906
        C339.781,344.072,328.152,332.472,313.807,332.472z"
        ></path>
      </g>
    </g>
  </svg>
);

export default AppleAppStoreSvgIcon;
